import React, { useState } from 'react';

import { useDebouncedValue } from '@mantine/hooks';
import { getWeekRangeDates } from 'utils/date-functions';

import AthleteBirthdaysPageHeader from './components/AthleteBirthdaysPageHeader';
import AthleteBirthdaysTable from './components/AthleteBirthdaysTable';
import { SearchFilters } from './types';

const AthleteBirthdays = (): JSX.Element => {
  const initialSearchFiltersValue: SearchFilters = {
    dateRange: getWeekRangeDates(),
    athleteStatuses: [],
  };

  const [searchFilters, setSearchFilters] = useState<SearchFilters>(initialSearchFiltersValue);
  const [debouncedSearchFilters] = useDebouncedValue<SearchFilters>(searchFilters, 250);
  const [orderingValue, setOrderingValue] = useState<string>('dob');

  return (
    <>
      <AthleteBirthdaysPageHeader
        initialSearchFiltersValue={initialSearchFiltersValue}
        searchFilters={searchFilters}
        setSearchFilters={setSearchFilters}
        orderingValue={orderingValue}
      />

      <AthleteBirthdaysTable searchFilters={debouncedSearchFilters} setOrderingValue={setOrderingValue} />
    </>
  );
};

export default AthleteBirthdays;
